import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY as crumbLabel } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel,
	dropdownList: {},
	filter: {
		PracovnikId: null as number | null,
		DatumOd: null as Date | null,
		DatumDo: null as Date | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
	},
	extraActions: {},
	extraMutations: {
		[types.mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.localState.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.localState.PracovnikOsobniCis = data.osobniCis;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => { },
	},
});
